import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import logo from '../../assets/logo.png'
import { useLocalStorage } from '../../hooks/useLocalStorage'
import { JWT_TOKEN_KEY_NAME } from '../../utils/constants'
import { translateStackTrace } from '../../utils/translateStackTrace' // ajuste o caminho conforme necessário
import { Button } from '../Button'

type CustomErrorFallbackProps = {
  error: unknown;
  componentStack?: string;
}

export const CustomErrorFallback = ({ error, componentStack }: CustomErrorFallbackProps) => {
  const [token] = useLocalStorage(JWT_TOKEN_KEY_NAME)
  const navigate = useNavigate()
  const [translatedStack, setTranslatedStack] = useState<string | null>(null)

  const errorObj = error instanceof Error
    ? error
    : new Error(String(error))

  useEffect(() => {
    if (error instanceof Error) {
      translateStackTrace(error).then(setTranslatedStack)
    }
  }, [error])

  const handleGoBack = () => {
    if (token) {
      navigate('/dashboard')
    } else {
      navigate('/')
    }
  }

  const handleShareError = async () => {
    const fullStack = translatedStack || componentStack || errorObj.stack || 'Sem stack trace disponível'
    const errorText = `Erro: ${errorObj.toString()}\n\nStack Trace:\n${fullStack}`

    if (navigator.canShare && navigator.canShare({ files: [] })) {
      const blob = new Blob([errorText], { type: 'text/plain' })
      const file = new File([blob], 'erro.txt', { type: 'text/plain' })
      try {
        await navigator.share({
          title: 'Relatório de Erro',
          files: [file],
        })
      } catch (shareError) {
        console.error('Erro ao compartilhar o arquivo:', shareError)
      }
    } else if (navigator.share) {
      try {
        await navigator.share({
          title: 'Relatório de Erro',
          text: errorText,
        })
      } catch (shareError) {
        console.error('Erro ao compartilhar o texto:', shareError)
      }
    } else if (navigator.clipboard) {
      try {
        await navigator.clipboard.writeText(errorText)
        alert('Detalhes do erro copiados para a área de transferência!')
      } catch (clipboardError) {
        console.error('Erro ao copiar para a área de transferência:', clipboardError)
      }
    } else {
      prompt('Copie os detalhes do erro:', errorText)
    }
  }

  return (
    <div className="flex w-[100vw] flex-col justify-center items-center pt-8">
      <div className="flex flex-col flex-1 justify-center items-center">
        <img
          src={logo}
          alt="Relatórios de Trademarketing"
        />
        <span className="text-center font-semibold mt-4">Relatórios de Trademarketing</span>
        <h3 className="text-center mt-9 text-2xl/9 font-bold tracking-tight text-gray-900">
          Ops, algo deu errado.
        </h3>
        <p className="my-6 w-[80%] text-center">
          Ocorreu um erro inesperado. Por favor, compartilhe os detalhes do erro para nos ajudar a resolver o problema.
        </p>
        <Button className="w-[80%]" onClick={handleShareError}>Compartilhar Erro</Button>
        <Button variant="outline" className="w-[80%] mt-2" onClick={handleGoBack}>Voltar à aplicação</Button>
      </div>
      <div className="max-w-[90%] overflow-auto mt-8 max-h-[40vh]">
        <pre className="bg-white text-wrap whitespace-pre-wrap text-sm">
          {translatedStack || componentStack || errorObj.stack}
        </pre>
      </div>
    </div>
  )
}
